module.exports = __webpack_public_path__ + "static/media/features_pic2.a06d7d02.jpg";